// extracted by mini-css-extract-plugin
module.exports = {"balanceSpan":"posDashboard_balanceSpan__6ODdW","balanceDisclaimer":"posDashboard_balanceDisclaimer__1_vWQ"};